import { FC, useCallback, useEffect } from 'react'
import { HeaderStyles } from 'components/atoms/ModuleLayout/ModuleLayout'
import { useForm } from 'react-hook-form'
import Flex from 'components/atoms/Flex/Flex'
import { LabeledInput } from 'components/atoms/inputs/LabeledInput/LabeledInput'
import { useStoreDispatch, useStoreSelector } from 'helpers/reactReduxHelpers'
import { FormPreset } from 'components/atoms/inputs/FormPreset/FormPreset'
import { State } from 'interfaces/state'
import { SetPreferences } from 'components/features/preferences/prerefencesReducer'
import { ENV } from 'constants/app'

export type Preferences = {
  'mainNavTextStyle': 'serif' | 'sans'
  'headerStyle': HeaderStyles
}

export const LOCAL_STORAGE_PREFERENCES_KEY = 'statusMoneyPreferences'

export const DEFAULT_PREFERENCES: Preferences = {
  mainNavTextStyle: 'sans',
  headerStyle: 'floating',
}


export const useLocalPreferences = (): Preferences => {
  const dispatch = useStoreDispatch()
  const storedPreferences = localStorage.getItem(LOCAL_STORAGE_PREFERENCES_KEY)
  const parsedPreferences = storedPreferences ? JSON.parse(storedPreferences) : null
  useEffect(() => {
    !!parsedPreferences && dispatch(new SetPreferences(parsedPreferences))
  }, [dispatch, parsedPreferences])

  return parsedPreferences
}

export const PreferenceControls: FC<{}> = () => {
  const storedPreferences = localStorage.getItem(LOCAL_STORAGE_PREFERENCES_KEY)
  const parsedPreferences = storedPreferences ? JSON.parse(storedPreferences) : null
  const statePreferences = useStoreSelector((state: State) => state.data.preferences)
  const formContext = useForm<Preferences>({
    defaultValues: parsedPreferences || statePreferences || DEFAULT_PREFERENCES,
  })

  const dispatch = useStoreDispatch()
  const handleFieldChange = useCallback((key, event) => {
    dispatch(new SetPreferences({ [key]: event.target.value }))
  }, [dispatch])

  if (ENV === 'prod') {
    return null
  }

  return (
    <FormPreset formContext={ formContext } onSubmit={ () => console.log('') }>
      <Flex marginBottom='large'>
        <LabeledInput<'serif' | 'sans'>
          label='Nav Style'
          name='mainNavTextStyle'
          type='radio'
          onChange={ (event) => handleFieldChange('mainNavTextStyle', event) }
          options={ [
            { label: 'Serif', value: 'serif' },
            { label: 'Sans', value: 'sans' },
          ] }
        />
        <LabeledInput<HeaderStyles>
          label='Header Style'
          name='headerStyle'
          type='radio'
          onChange={ (event) => handleFieldChange('headerStyle', event) }
          options={ [
            { label: 'Floating', value: 'floating' },
            { label: 'Connected', value: 'connected' },
            { label: 'Nested', value: 'nested' },
          ] }
        />
      </Flex>
    </FormPreset>
  )
}

export default PreferenceControls


